import styled from 'styled-components';

export const IllustrationWrapper = styled.div`
  font-size: 18px;
  width: 100%;
  height: 100%;
  text-align: center;
  margin: auto;
  margin-top: 20px;
`;

export const PageWrapper = styled.div`
  padding: 100px;
  min-height: 100vh;
`;
